import { createStatsProSlice } from '../statsProSlice';
import { DATA_TYPE } from 'widgets/statspro/js/components/common/config/data-type';

/**
 * @typedef {StatsProState & {
 *      nav: StatsProNavState & {
 *          category: string
 *      }
 * }} CareerAndSeasonStatsState
 */

/**
 * @type {CareerAndSeasonStatsState}
 */
const initialState = {
    nav: {
        category: 'Key Stats',
        season: {
            id: -1
        },
        round: {
            id: null,
            number: null
        }
    },
    dataType: {
        type: DATA_TYPE.AVERAGES
    }
};

export const careerAndSeasonStatsSlice = createStatsProSlice({
    name: 'career-and-season-stats',
    initialState,
    mergeKeys: ['nav', 'dataType']
});

export const careerAndSeasonStatsReducer = careerAndSeasonStatsSlice.reducer;
export const careerAndSeasonStatsActions = careerAndSeasonStatsSlice.actions;
